import { c as _c } from "react/compiler-runtime";
import { Checkbox, toast } from '@systemeio/ui';
import Option from 'modules/products/components/Options/option';
import ProductErrorsInterface from 'modules/products/types/error-response-content-interface';
import { ProductOptionInterface, ProductOptionValueInterface } from 'modules/products/types/product-option-interface';
import { getVariants } from 'modules/products/utils/product-variants-utils';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ulid } from 'ulid';
import { PlusIcon } from '@systemeio/ui/icons';
interface OptionsProps {
  options: ProductOptionInterface[];
  setOptions: React.Dispatch<React.SetStateAction<ProductOptionInterface[]>>;
  errors: Record<string, Record<string, string[]>>;
  setErrors: React.Dispatch<React.SetStateAction<ProductErrorsInterface>>;
  maxProductVariants: number;
}
function Options(t0) {
  const $ = _c(40);
  const {
    options,
    setOptions,
    errors,
    setErrors,
    maxProductVariants
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [variantOverloadError, setVariantOverloadError] = useState("");
  const [isChecked, setIsChecked] = useState(!!options.length);
  const [toastShown, setToastShown] = useState(false);
  let handleAddOption;
  let handleOnChangeCheckbox;
  if ($[0] !== setOptions) {
    handleOnChangeCheckbox = checked => {
      if (checked) {
        handleAddOption();
      } else {
        setOptions([]);
      }
      setIsChecked(checked);
    };
    handleAddOption = () => {
      const newOption = {
        id: ulid(),
        name: "",
        optionValues: [] as ProductOptionValueInterface[]
      };
      const newOptionValue = {
        id: ulid(),
        value: ""
      };
      newOption.optionValues.push(newOptionValue);
      setOptions(prev => [...prev, newOption]);
    };
    $[0] = setOptions;
    $[1] = handleAddOption;
    $[2] = handleOnChangeCheckbox;
  } else {
    handleAddOption = $[1];
    handleOnChangeCheckbox = $[2];
  }
  let t1;
  if ($[3] !== setErrors || $[4] !== setOptions) {
    t1 = optionId => e => {
      setOptions(prev_0 => prev_0.map(o => o.id === optionId ? {
        ...o,
        name: e.target.value
      } : o));
      setErrors(prev_1 => {
        const oldState = {
          ...prev_1
        };
        if (Object.keys(oldState.options).includes(optionId)) {
          delete oldState.options[optionId];
        }
        return oldState;
      });
    };
    $[3] = setErrors;
    $[4] = setOptions;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleChangeOptionName = t1;
  const handleChangeOptionValue = optionId_0 => (e_0, optionValueId) => {
    setVariantOverloadError("");
    const targetOption = options.find(o_0 => o_0.id === optionId_0);
    if (targetOption) {
      const filteredOptionValues = targetOption.optionValues.map(o_1 => o_1.id === optionValueId ? {
        ...o_1,
        value: e_0.target.value
      } : o_1).filter(_temp);
      const updatedOption = {
        ...targetOption,
        optionValues: filteredOptionValues.length > 0 ? filteredOptionValues : [{
          id: ulid(),
          value: ""
        }]
      };
      const variantsCount = getVariants(options.map(o_3 => o_3.id === optionId_0 ? updatedOption : o_3), []).length;
      if (variantsCount <= maxProductVariants) {
        setOptions(prev_2 => prev_2.map(o_4 => o_4.id === optionId_0 ? updatedOption : o_4));
        addEmptyOptionValue(updatedOption);
      } else {
        if (!toastShown) {
          setToastShown(true);
          toast.error(t("dashboard.products.variants.overload.error_message", {
            numberOfVariants: maxProductVariants
          }));
        }
      }
    }
  };
  const addEmptyOptionValue = option => {
    if (option.optionValues[option.optionValues.length - 1]?.value) {
      const newOptionValue_0 = {
        id: ulid(),
        value: ""
      };
      const updatedOption_0 = {
        ...option,
        optionValues: [...option.optionValues, newOptionValue_0]
      };
      setOptions(prev_3 => prev_3.map(o_5 => o_5.id === option.id ? updatedOption_0 : o_5));
    }
  };
  let t2;
  if ($[6] !== setOptions) {
    t2 = optionId_1 => () => {
      setOptions(prev_4 => prev_4.filter(o_6 => o_6.id !== optionId_1));
    };
    $[6] = setOptions;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleDeleteOption = t2;
  let t3;
  if ($[8] !== options || $[9] !== setOptions) {
    t3 = optionId_2 => (e_1, optionValueId_0) => {
      setVariantOverloadError("");
      const targetOption_0 = options.find(o_7 => o_7.id === optionId_2);
      if (targetOption_0) {
        const filteredOptionValues_0 = targetOption_0.optionValues.filter(o_8 => o_8.id !== optionValueId_0);
        const updatedOption_1 = {
          ...targetOption_0,
          optionValues: filteredOptionValues_0
        };
        setOptions(prev_5 => prev_5.map(o_9 => o_9.id === optionId_2 ? updatedOption_1 : o_9));
      }
    };
    $[8] = options;
    $[9] = setOptions;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleDeleteOptionValue = t3;
  let t4;
  if ($[11] !== options.length) {
    t4 = () => {
      setIsChecked(!!options.length);
    };
    $[11] = options.length;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== options) {
    t5 = [options];
    $[13] = options;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[15] !== toastShown) {
    t6 = () => {
      if (toastShown) {
        setTimeout(() => {
          setToastShown(false);
        }, 3000);
      }
    };
    t7 = [toastShown];
    $[15] = toastShown;
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  if ($[18] !== t) {
    t8 = t("dashboard.products.options.confirm");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== handleOnChangeCheckbox || $[21] !== isChecked || $[22] !== t8) {
    t9 = <div className="mt-4"><Checkbox value={isChecked} onChange={handleOnChangeCheckbox} label={t8} /></div>;
    $[20] = handleOnChangeCheckbox;
    $[21] = isChecked;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = "my-2";
  let t11;
  if ($[24] !== isChecked) {
    t11 = isChecked && <hr className="border-text-secondary -ml-6 -mr-6 mb-2 mt-2 border-t-[1.5px] border-solid opacity-40" />;
    $[24] = isChecked;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = options.map(option_0 => <Option option={option_0} key={option_0.id} changeOptionName={handleChangeOptionName(option_0.id)} changeOptionValue={handleChangeOptionValue(option_0.id)} deleteOption={handleDeleteOption(option_0.id)} deleteOptionValue={handleDeleteOptionValue(option_0.id)} addEmptyOptionValue={addEmptyOptionValue} error={Object.keys(errors).includes(option_0.id) ? errors[option_0.id]?.name?.join("") || "" : ""} errorOptionValues={Object.keys(errors).includes(option_0.id) ? errors[option_0.id]?.optionValues?.join("") : ""} />);
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div className={t10}>{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== variantOverloadError) {
    t14 = variantOverloadError && <div className="text-danger flex items-center justify-center">{variantOverloadError}</div>;
    $[29] = variantOverloadError;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== handleAddOption || $[32] !== isChecked || $[33] !== t) {
    t15 = isChecked && <button className="text-brand-primary mt-4 flex cursor-pointer gap-1" onClick={handleAddOption}><PlusIcon fill="rgb(var(--brand-primary))" />{t("dashboard.products.options.add_options.title")}</button>;
    $[31] = handleAddOption;
    $[32] = isChecked;
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t14 || $[37] !== t15 || $[38] !== t9) {
    t16 = <>{t9}{t13}{t14}{t15}</>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t9;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
}
function _temp(o_2) {
  return !!o_2.value;
}
export default Options;